import Logo from "./header-logo";

import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/tooltip";
import { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import PassportIcon from "@/assets/svgs/passports";
import { Menu, X } from "lucide-react";

function ParentsNavigationBar() {
  const { t } = useTranslation("Home");

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();

  const menuItems = [
    {
      id: 1,
      logo: <PassportIcon />,
      href: "/parents/passport",
      name: t("passport"),
    },
    {
      id: 2,
      logo: <Icon icon="mdi:email-outline" width="30" height="30" />,
      href: "/parents/send-email",
      name: t("messageMentor"),
    },
  ];

  return (
    <>
      <div className="pb-[1.5rem] pt-[2.5rem]">
        <div className="hidden xl:flex justify-between col-span-1">
          <Logo handleClick={() => navigate("/parents/passport")} />
          <div className="flex justify-between items-center gap-4">
            <div
              id="navigation-menu"
              className="bg-[#f49b4b]  p-2 w-fit flex justify-center items-center gap-[24px] h-fit rounded-[100px]"
            >
              {menuItems.map((item) => (
                <TooltipProvider key={item.id}>
                  <Tooltip>
                    <TooltipTrigger>
                      <NavLink
                        to={item.href}
                        className={({ isActive }) =>
                          `flex items-center gap-2 p-4 cursor-pointer hover:bg-[#FFD1A5] hover:rounded-[100px] transition-all duration-300 ease-in-out ${isActive ? "bg-[#FFD1A5] rounded-[100px]" : ""
                          }`
                        }
                      >
                        {item.logo}
                      </NavLink>
                    </TooltipTrigger>
                    <TooltipContent>
                      <div className="text-center text-[12px] font-bold">
                        {item.name}
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile Hamburger Menu (Tablet and below) */}
        <div className="xl:hidden fixed top-4 left-4 z-50">
          <button
            data-testid="mobile-menu-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="  bg-white p-2 rounded-md shadow-md"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Dropdown Drawer */}
        {isMenuOpen && (
          <div className="fixed top-0 left-0 w-fit h-full bg-[#f49b4b]  z-40 p-6 flex flex-col gap-6 shadow-lg">
            <Logo />
            {menuItems.map((item) => (
              <NavLink
                key={item.id}
                to={item.href}
                onClick={() => setIsMenuOpen(false)}
                className="flex items-center gap-3 p-3 hover:bg-[#FFD1A5] rounded-md "
              >
                {item.logo}
                <span className="font-bold">{item.name}</span>
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default ParentsNavigationBar;
